/**
 * Every user-facing string on the orders screen, in one place.
 *
 * Filter enums reference these directly, so a chip's label and the filter it
 * applies can never drift apart.
 */
import moment from "moment";
export const COPY = {
  title: 'Orders',
  titleSelf: 'My orders',

  // Status vocabulary
  all: 'All',
  paid: 'Paid',
  pending: 'Pending',
  invoice: 'Invoice',
  canceled: 'Canceled',

  // Summary band
  cash: 'Cash',
  discount: 'Discount',
  exportPdf: 'Export PDF',

  // Filters
  allWaiters: 'All waiters',
  searchPlaceholder: 'Order no., customer or item',
  clearFilters: 'Clear filters',
  widenRange: 'Widen to 7 days',

  // Date presets
  today: 'Today',
  yesterday: 'Yesterday',
  last7: 'Last 7 days',
  thisMonth: 'This month',
  apply: 'Apply',

  // Paying, and where the money landed
  payTitle: (no) => `Pay · Dalab #${no}`,
  amount: 'Amount',
  includingVat: (vat) => `including ${vat} VAT`,
  whereDidItLand: 'Where did it land?',
  chooseAccount: 'Choose an account',
  takeTo: (amount, account) => `Take ${amount} to ${account}`,
  // Cash is not one of the business's paytoAccounts — it is the absence of
  // one — so the word for it lives here rather than in the data.
  cashAccount: 'Cash',
  drawer: 'Drawer',
  paidInto: 'Paid into',
  unassigned: 'Unassigned',
  cashSplit: 'Cash received, split by where it landed',
  showAccounts: 'Show the accounts',
  hideAccounts: 'Hide the accounts',

  // Row and panel actions
  pay: 'Pay',
  // The button that puts a settled order back. "Mark pending" described the
  // state it lands in; "Restore" describes what the person is doing.
  markPending: 'Restore',

  // Detail panel
  customer: 'Customer',
  date: 'Date',
  servedBy: 'Served by',
  orderType: 'Order type',
  item: 'Item',
  qty: 'Qty',
  price: 'Price',
  total: 'Total',
  grossTotal: 'Gross total',
  // The rate is the one stored ON the order, not today's business setting: a
  // sale made last year at 5% must keep saying 5% after the rate changes.
  vatLine: (rate) => (rate ? `VAT (${rate}%)` : 'VAT'),
  grandTotal: 'Wadarta Guud',
  printReceipt: 'Print receipt',
  billToCustomer: 'Bill to customer',
  kitchenTicket: 'Kitchen ticket',
  noStations:
    'None of these items print a kitchen ticket. Check which printer each category uses in Administration.',
  print: 'Print',
  edit: 'Edit',
  cancelOrder: 'Cancel order',
  noSelectionTitle: 'No order selected',
  noSelectionBody: 'Pick an order from the list to see its items and print the receipt.',

  // Cancel dialog
  cancelTitle: (n) => `Cancel order #${n}?`,
  cancelReasonLabel: 'Reason',
  cancelReasonPlaceholder: 'Sababta joojinta — e.g. macmiilku waa laba jeer la diiwaan geliyey',
  keepOrder: 'Keep order',

  // States
  emptyTitle: 'No orders found',
  errorTitle: 'Could not reach the server',
  errorBody: 'Check the shop internet and try again. Orders already placed are safe.',
  retry: 'Try again',

  // Roles
  waiterNotice:
    'Waiters see only their own orders, locked to today. No shop totals, no export.',

  orders: (n) => (n === 1 ? '1 order' : `${n} orders`),
  items: (n) => (n === 1 ? '1 item' : `${n} items`),
};

/**
 * Month names as the shop writes them. `moment`'s MMM gives "Sep"; the design
 * asks for "Sept", so the table is explicit rather than patched at the call
 * site.
 */
const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec',
];

/** "19 Sept 2026 01:55PM" — the form every order row carries. */
// export const formatRowDateTime = (m) =>   moment.utc(m).format("YYYY-MM-DD hh:mm:ss A");   
  // `${m.date()} ${MONTHS[m.month()]} ${m.year()} ${m.format('hh:mmA')}`;
  export const formatRowDateTime = (m) =>
  moment.utc(m).format("D MMM YYYY · h:mmA");

/** "19 Sept 2026 · 01:55PM" — the same date, given room in the panel. */
export const formatPanelDateTime = (m) => 
  `${m.date()} ${MONTHS[m.month()]} ${m.year()} · ${m.format('hh:mmA')}`;

/** "19 Sept 2026" — no time. */
export const formatDay = (m) => `${m.date()} ${MONTHS[m.month()]} ${m.year()}`;

/** Money, always with two decimals and a leading sign for the currency. */
export const money = (value, mark = '$') => {
  const n = Number(value);
  return `${mark}${(Number.isFinite(n) ? n : 0).toFixed(2)}`;
};
